import { render } from "./HospitalTypeChart.vue?vue&type=template&id=59ba296e&scoped=true"
import script from "./HospitalTypeChart.vue?vue&type=script&lang=js"
export * from "./HospitalTypeChart.vue?vue&type=script&lang=js"

import "./HospitalTypeChart.vue?vue&type=style&index=0&id=59ba296e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ba296e"]])

export default __exports__